var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 6.66658C2.66675 3.72107 5.05456 1.33325 8.00008 1.33325C10.9456 1.33325 13.3334 3.72107 13.3334 6.66658V13.3333C13.3334 14.0697 12.7365 14.6666 12.0001 14.6666H4.00008C3.2637 14.6666 2.66675 14.0697 2.66675 13.3333V6.66658Z",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 12H5.33341C4.96523 12 4.66675 12.2985 4.66675 12.6667V14.6667",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9.33325H7.99992C7.63172 9.33325 7.33325 9.63172 7.33325 9.99992V11.9999",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.66675H10.6667C10.2985 6.66675 10 6.96521 10 7.33341V9.33341",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnt);
export default __webpack_public_path__ + "static/media/ent.889b52688b540fb8b53c03c668f41903.svg";
export { ForwardRef as ReactComponent };